import { Util } from './../../app/util';
import { Component, Injector } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';

import { Dashboard } from '../dashboard/dashboard';
import { UserSignup } from '../user-signup/user-signup';
import { UserForgotpassword } from '../user-forgotpassword/user-forgotpassword';
import { Http } from '@angular/http';
import { Storage } from '@ionic/storage';
import { HrListCampionatiPage } from '../hr_listcampionati/hr_listcampionati';
import { ThrowStmt } from '@angular/compiler/src/output/output_ast';
import { UserLogin } from '../user-login/user-login';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'page-hr_login',
  templateUrl: 'hr_login.html',
})
export class HrLogin extends Util {
  user: string = "";
  pass: string = "";
  serr: any;
  showlogin:boolean = false;
  token: string = '';
  showtoken:boolean = false;
  constructor(public navCtrl: NavController, public translate: TranslateService,public navParams: NavParams, injector: Injector, loading: LoadingController) {
    super(injector, loading);
    // let url = document.URL.split('#')[0];
    
    // url = url.replace('http://','');
    // url = url.replace('https://','');
    
    // if(url.slice(0,3) != 'loc')
    //   this.navCtrl.setRoot(UserLogin);
    //this.storage.remove('user');
    //this.storage.clear();

    //this.user = "m.rossi";
    //this.pass = "polizia";
    
  }
  // ngAfterViewInit() {
  // }


  have_token(){
    this.showtoken = !this.showtoken;
  }
  logout() {
    this.storage.remove('user');
    // this.storage.clear();
    this.showlogin = true;
    // window.location.reload();
  }
  ngAfterViewInit() {


    this.storage.get('user').then(user => {

      // //console.log(user);
      if (user != null && user != undefined && user != '') {

          // this.loginWithUserEPass(user.username, user.password, false, false);
        this.GetRequest('checksession', '',false,true).then((res) => {
          this.navCtrl.push(HrListCampionatiPage);
        }).catch((err)=>{
          //console.log(err);
          this.logout();
        })
        
        // this.loginWithUserEPass(user.username, user.password, false, false);
      }
      else{
        this.showlogin = true;
      }
    });

  }

  loginWithUserEPass(email: string, password: string, showAlert: boolean, savepass: boolean) {

    this.PostRequest('login', '', { username: email, password: password, hr:1 }, showAlert).then(data => {
      //console.log(data);

      if (savepass) {
        // var datasave = data;
        var datasave = {token:data['user']['token'],id:data['user']['id']};
        // datasave['user']['password'] = this.pass;
        this.storage.set('user', datasave).then(() => {
          this.gs.myuser = datasave['user'];
          if(this.showtoken)
            this.send_token();
          //console.log('data--->',data);
          this.navCtrl.push(HrListCampionatiPage);
        })
      }
      else {
        // var datasave = data;
        // datasave['user']['password'] = password;
        var datasave = {token:data['user']['token'],id:data['user']['id']};

        this.storage.set('user', datasave).then(() => {
          this.gs.myuser = datasave['user'];
          //console.log('data --->',data);
          this.navCtrl.push(HrListCampionatiPage);
        })
      }


    }).catch(err => {
      this.showlogin = true;
      if (showAlert) {

        var error_str = this.etic.en.errorlogin;
        if (err != null && err != undefined && err.errors != null) {
          error_str = err.errors;
        }
        //this.showBasicAlert('Errore', error_str);
        this.serr = JSON.stringify(err);
      }
      this.storage.remove('user');
      // this.storage.clear();
    });
  }

  login() {
    this.loginWithUserEPass(this.user, this.pass, true, true);
  }
  
  send_token(){
    this.PostRequest('attivaToken',this.token,{},true,true).then((res:any)=>{
      this.showBasicAlert('Token',res.message);
      //console.log(res);
    }).catch((err)=>{
      console.error(err);
    })
  } 

  /*
    ionViewDidLoad() {
      
      //this.pass = "polizia";
  
      this.storage.get('user').then(user => {
        //console.log(user);
        
        if (user != null) {
          this.loginWithUserEPass(user.user.nomeutente, user.user.password, false);
        }
      });
  
    }
  
    loginWithUserEPass(email: string, password: string, showAlert: boolean) {
      this.PostRequest('login', '', { username: email, password: password }, showAlert).then(data => {
        
        this.storage.set('user', data);
        this.navCtrl.push(Dashboard,{user:data});
        
      }).catch(err => {
        
        if (showAlert) {
  
          var error_str = this.etic.en.errorlogin;
          if (err != null && err != undefined && err.errors != null) {
            error_str = err.errors;
          }
          //this.showBasicAlert('Errore', error_str);
          this.serr = JSON.stringify(err);
        }
        this.storage.clear();
      });
    }
  
    login() {
      this.loginWithUserEPass(this.user, this.pass, true);
    }
  */
  dashboardPage() { this.navCtrl.push(Dashboard, { user: this.user }); }
  signupPage() { this.navCtrl.push(UserSignup); }
  forgotPasswordPage() { this.navCtrl.push(UserForgotpassword); }

}



// WEBPACK FOOTER //
// ./src/pages/hr_login/hr_login.ts